import DataSourceTypeDetailDto from "./DataSourceTypeDetailDto";
import UserDto from "../accountmodule/UserDto";

class DataSourceListDto {
    Id: number;
    Name: string;
    Type: DataSourceTypeDetailDto;
    ConnectorType: string;
    CreatedBy: UserDto;

    constructor(id: number, name: string, type: DataSourceTypeDetailDto, connectorType: string, createdBy: UserDto) {
        this.Id = id;
        this.Name = name;
        this.Type = type;
        this.ConnectorType = connectorType;
        this.CreatedBy = createdBy;
    }
}

export default DataSourceListDto;
